import React                             from 'react';
import {render,  unmountComponentAtNode} from 'react-dom';
import PjaxWrapper                       from '../../utils/PjaxWrapper';
import AllBlocks                         from '../../components/Homepage/AllBlocks';

export function run(pmJsom) {
	const pm = JSON.parse(pmJsom);
	const el = document.getElementById('homepage');

	render((<AllBlocks {...pm} />), el);
	PjaxWrapper.addUnloadFunc(() => unmountComponentAtNode(el));
}

